<template>
    <div class="login-container">
  
      <div class="top-div">
        <div class="back-button" @click="$router.push('/auth')">◀</div>
        <div class="title">
          <p>Connexion</p>
        </div>
      </div>

      <div class="login-form-div">
        <form class="login-form" @submit.prevent="login">
          <input v-model="email" type="email" placeholder="E-mail" required />
          <input v-model="password" type="password" placeholder="Mot de passe" required />
        </form>
  
        <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
  
        <p class="social-text">Log in with social account</p>
        <div class="social-buttons">
          <button class="circle google" />
          <button class="circle facebook" />
          <button class="circle other" />
        </div>
  
        <div class="send-form">
          <button class="login-btn" @click="login">Log In</button>
          <a class="forgot" @click="$router.push('/auth/forgot')">Forgot your password?</a>
        </div>
      </div>
  
    </div>
  </template>
  
  <script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import axios from 'axios';

const email = ref('');
const password = ref('');
const errorMessage = ref('');
const router = useRouter();

const login = async () => {
  console.log('Tentative de connexion avec', email.value, password.value);
  try {
    const response = await axios.post('http://aaaa:300/...', {
      email: email.value,
      password: password.value
    }, { withCredentials: true });

    if (response.status === 201) {
      router.push('/');
    }
  } catch (error) {
    console.error(error);
    errorMessage.value = "Erreur d'authentification. Vérifiez vos identifiants.";
  }
};
</script>
  
  <style scoped>
  .login-container {
    display: flex;
    flex-direction: column;
    height: 100vh;
    font-family: 'Arial', sans-serif;
    color: #333;
  }
  
  .top-div {
    height: 10vh;
    display: flex;
    align-items: center;
    position: relative;
    padding: 0 2vw;
  }
  
  .back-button {
    height: 100%;
    aspect-ratio: 1 / 1;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 2.5vh;
    border-radius: 50%;
    z-index: 2;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    cursor: pointer;
  }
  
  .title {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
  
  .title p {
    font-size: 4vh;
    font-weight: bold;
  }
  
  .login-form-div {
    flex: 1;
    background-color: white;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    padding: 5vh 6vw;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  
  .login-form {
    display: flex;
    flex-direction: column;
    gap: 2vh;
  }
  
  .login-form input {
    width: 100%;
    height: 6vh;
    border: none;
    border-radius: 30px;
    padding: 0 1.5vw;
    background-color: #f0f0f0;
    font-size: 2vh;
    box-shadow: inset 0 2px 4px rgba(0,0,0,0.05);
  }
  
  .error-message {
    color: #e53935;
    font-size: 1.8vh;
    text-align: center;
    margin-top: 1vh;
  }
  
  .social-text {
    text-align: center;
    font-size: 1.8vh;
    color: #999;
    margin: 4vh 0 2vh;
  }
  
  .social-buttons {
    display: flex;
    justify-content: center;
    gap: 5vw;
    margin-bottom: 4vh;
  }
  
  .circle {
    width: 6vh;
    height: 6vh;
    border-radius: 50%;
    border: none;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    cursor: pointer;
  }
  
  .google {
    background: url('https://img.icons8.com/color/48/google-logo.png') no-repeat center;
    background-size: 60%;
  }
  .facebook {
    background: url('https://img.icons8.com/color/48/facebook-new.png') no-repeat center;
    background-size: 60%;
  }
  .other {
    background: url('https://img.icons8.com/color/48/circled-user-male-skin-type-1-2.png') no-repeat center;
    background-size: 60%;
  }
  
  .send-form {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2vh;
  }
  
  .login-btn {
    width: 100%;
    height: 6vh;
    border: none;
    border-radius: 30px;
    background: linear-gradient(to right, #7832dc, #ea4c89);
    color: white;
    font-weight: bold;
    font-size: 2vh;
    box-shadow: 0 4px 10px rgba(0,0,0,0.2);
    cursor: pointer;
  }
  
  .forgot {
    font-size: 1.6vh;
    color: #999;
    text-decoration: underline;
    cursor: pointer;
  }
  </style>